import { getIssueAssembleInfo } from '@issue-detail/components/IssueDrawer/Api/issue';
import { IssueAssembleResponse } from '@issue-detail/components/IssueDrawer/Model/issue';
import { useI18n } from '@issue-detail/utils/useI18n';
import { useRootInstance } from '@issue-detail/utils/useRootInstance';
import { useVuex } from '@issue-detail/utils/useVuex';
import { computed, ref, Ref, watch } from '@vue/composition-api';

import {
  getCreateIssueInfoWarper$,
  getIssueDetailObservable$,
  getIssueDetailWarper
} from '../DataWarper/issue';
import { ActionStore, AllIssueDrawerAction } from './action';
import { ShareStore } from './share';

export const useIssue = (
  actionStore: ActionStore,
  { isVisitor }: ShareStore
) => {
  const issueAssemble = ref<IssueAssembleResponse | null>(null);
  const instance = useRootInstance();
  const vuex = useVuex();
  const { t } = useI18n();

  const issueReport = (issueId: number, projectId: number) => {
    const dataId = issueId;
    const userId = vuex.state.user.account.userId;
    const eventGroupCode = 'layout';
    const eventGroupId = 7;
    const eventId = 7;
    instance.$track.send('issue_click', {
      eventGroupId,
      dataId,
      projectId,
      userId,
      eventGroupCode,
      eventId
    });
  };

  const isLoadComplete = ref(false);

  const refreshIssueDetail = async (
    action: AllIssueDrawerAction | null,
    force = false
  ) => {
    issueAssemble.value = null;
    isLoadComplete.value = false;

    try {
      if (action?.type === 'Edit') {
        getIssueDetailObservable$(
          actionStore.localDb.value,
          action.issueId,
          action.force || force
        ).subscribe({
          next: (issue) => {
            if (
              action &&
              'issueId' in action &&
              issue.issueVO?.id === action.issueId
            ) {
              issueAssemble.value = issue;
            }
          },
          complete: () => {
            if (issueAssemble.value?.issueVO) {
              isLoadComplete.value = true;
              if (!isVisitor.value) {
                issueReport(
                  issueAssemble.value.issueVO.id,
                  issueAssemble.value.issueVO.projectId
                );
              }
            }
          },
          error: (e) => {
            if (e.deleteIssueExtendVO) {
              if (!e.deleteIssueExtendVO.showPerm) {
                // 被移出项目、组织后
                actionStore.close();
                instance.eventBus.$emit('permission-change', false);
                return;
              }
              const res = {
                ...e.deleteIssueExtendVO,
                id: action.issueId
              };
              // issue被删除后 显示删除提示
              actionStore.markIssueIsDeleted(true, res);
              return;
            }
            actionStore.close();
          }
        });
      } else if (action?.type === 'Create' || action?.type === 'PreviewType') {
        getCreateIssueInfoWarper$(
          actionStore.localDb.value,
          action.projectId,
          action.issueTypeId,
          undefined,
          force
        ).subscribe({
          next: (issue) => {
            issueAssemble.value = issue;
          },
          complete: () => {
            isLoadComplete.value = true;
          }
        });
      }
    } catch (e: any) {
      if (e.deleteIssueExtendVO) {
        if (!e.deleteIssueExtendVO.showPerm) {
          // 被移出项目、组织后
          close();
          instance.eventBus.$emit('permission-change', false);
          return;
        }
        const res = {
          ...e.deleteIssueExtendVO,
          id: action?.issueId
        };
        // issue被删除后 显示删除提示
        actionStore.markIssueIsDeleted(true, res);
        return;
      }
      if (e && e.res?.code === '008') {
        // 被移出项目、组织后
        close();
        instance.eventBus.$emit('permission-change', false);
        return;
      }
      if (e.message) {
        instance.$message.error(e.message);
      }
    }
  };

  watch(actionStore.action, (action) => refreshIssueDetail(action, false), {
    immediate: true
  });

  const isPin = computed(() => issueAssemble.value?.pinStatus === 1);

  return { issueAssemble, refreshIssueDetail, isPin, isLoadComplete };
};
export type IssueStore = ReturnType<typeof useIssue>;
